import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface SummaryCardProps {
  title: string;
  value: number;
  subtitle: string;
  accentColor: 'rose' | 'orange' | 'purple' | 'red' | 'anthracite';
  icon: ReactNode;
  valueClassName?: string;
  linkTo?: string;
}

const accentClasses: Record<string, string> = {
  rose: 'border-l-4 border-l-brand-rose',
  orange: 'border-l-4 border-l-brand-orange',
  purple: 'border-l-4 border-l-brand-purple',
  red: 'border-l-4 border-l-red-600',
  anthracite: 'border-l-4 border-l-brand-anthracite',
};

export function SummaryCard({ title, value, subtitle, accentColor, icon, valueClassName, linkTo }: SummaryCardProps) {
  const content = (
    <div className="flex items-center justify-between">
      <div>
        <p className="text-xs font-bold uppercase tracking-wider text-slate-400">{title}</p>
        <p className={`text-3xl font-bold mt-1 ${valueClassName || 'text-slate-800'}`}>{value}</p>
        <p className={`text-xs mt-1 ${accentColor === 'red' ? 'text-red-400' : 'text-slate-400'}`}>{subtitle}</p>
      </div>
      {icon}
    </div>
  );

  const className = `glass-card rounded-xl p-5 ${accentClasses[accentColor]} ${linkTo ? 'hover:shadow-md transition-shadow cursor-pointer' : ''}`;

  if (linkTo) {
    return (
      <Link to={linkTo} className={className}>
        {content}
      </Link>
    );
  }

  return <div className={className}>{content}</div>;
}
